import { GetProjectorResult } from "results/frankenstories/GetProjectorResult";
import { useApiService } from "services/ApiService";

export const ProjectorApiService = () => {
    const { get } = useApiService({ controller: "/projector" });

    return {
        getProjector: (code: string) => get<GetProjectorResult>(`/projector/${code}`),
        getApprovingRepliesCount: (code: string) => get<number>(`/projector/${code}/approving-replies-count`),
    };
};
